import * as DomHelper from "../Helpers/DomHelper";
import { updateBlob } from "../Helpers/BlobHelper";
import { cancel } from "../Helpers/ExecutionStatus";
import { determineAndOrganizeErrors } from "./ErrorHelper";
const global = window;
const { selfHelp: { resources } } = global;
const { statusIconVals } = DomHelper;
/**
 * Updates blob with response data. If no responses, sets diagnostics data to failure scenario.
 *
 * @param key - the key for which task's responses are being updated
 * @param responses - the ajax responses
 */
function createBlobData(key, responses) {
    if (cancel) {
        return;
    }
    let diagnostics;
    if (responses.length) {
        const { organizedResponseArr, containsErrors } = determineAndOrganizeErrors(responses);
        diagnostics = {
            success: !containsErrors,
            details: organizedResponseArr,
        };
    }
    else {
        diagnostics = {
            success: false,
            details: resources.Endpoints_noEndpointsAvailable,
        };
    }
    updateBlob(key, diagnostics);
}
/**
 * Updates the DOM with organized responses (errors showing first). If no responses, creates display for that as well.
 *
 * @param key - which task was ran
 * @param responses - the responses for that task
 */
function updateDisplay(key, responses) {
    if (cancel) {
        return;
    }
    let displayIcon;
    if (responses.length) {
        const { errorCount, organizedResponseArr, containsErrors } = determineAndOrganizeErrors(responses);
        displayIcon = containsErrors ? statusIconVals.error : statusIconVals.success;
        const responseCount = {
            displayedResponses: errorCount,
            totalResponses: organizedResponseArr.length,
        };
        DomHelper.createEndpointResponseDisplay(key, organizedResponseArr, containsErrors, responseCount);
    }
    else {
        displayIcon = statusIconVals.error;
        DomHelper.createMoreDetailsSection(key, resources.Endpoints_noEndpointsAvailable);
    }
    DomHelper.displayStatusIcon(key, displayIcon);
    DomHelper.makeBarGrow(key);
}
/**
 * Handles majority of end test functionality for each of the endpoint response sections, including
 * updating the DOM, organizing responses to have errors first, updating blob, and changing the status
 * icon on the page.
 *
 * @param {string} key the table for which we are updating
 * @param {EndpointResponse[]} responses the responses for which we are updating
 */
export function endTest(key, responses) {
    createBlobData(key, responses);
    // There is no DOM display for the hosting service extensions
    if (key !== "hostingService") {
        updateDisplay(key, responses);
    }
}
/**
 * Formats the Hosting Service endpoints, performing the requisite replacements inside the URI.
 *
 * @param rawUri The raw URI to format.
 * @param extName The extension name.
 * @returns The formatted service endpoint.
 */
export function formatHostingServiceEndpoints(rawUri, extName) {
    const url = rawUri
        .replace(/\{extName\}/g, extName ?? "")
        .replace(/\{suffix\}/g, "")
        .replace("{0}", "")
        .replace(/\/$/, "");
    return new URL(url);
}
//# sourceMappingURL=EndpointHelper.js.map